export default {
    "images.ctfassets.net": "contentful",
    "cdn.builder.io": "builder.io",
    "images.prismic.io": "imgix",
    "www.datocms-assets.com": "imgix",
    "cdn.sanity.io": "imgix",
    "images.unsplash.com": "imgix",
    "cdn.shopify.com": "shopify",
    "s7d1.scene7.com": "scene7",
    "ip.keycdn.com": "keycdn",
    "assets.caisy.io": "bunny",
    "images.contentstack.io": "contentstack",
    "ucarecdn.com": "uploadcare",
    "imagedelivery.net": "cloudflare_images"
};
